import React, { useState } from 'react';
import TableCrud from '../../components/TableCrud';

import { Spreadsheet, createEmptyMatrix } from 'react-spreadsheet';
import { useEffect } from 'react';
import { FaTrashAlt } from 'react-icons/fa';
import { IoMdOptions } from 'react-icons/io';
import { Si } from 'react-icons/si';
import Api, { exceptionNotificationAPI } from '../../services/api';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { Container, ContainerHeader } from './styles';
import Button from '../../components/Button';
import { success_message, info_message, error_message } from '../../components/Toast/index';
import TableLoading from '../../components/TableLoading';
import { NumericFormat } from 'react-number-format';
import Swal from 'sweetalert2';

import optionsLogo from '../../assets/icons/options.svg';
import { formSelectStyles, formSelectControlFullWidth } from '../../components/FormInput/formSelectStyles';




const AdditionalDataDefaultValuesForm = () => {
    const columns = ["RefNumber", "Value", " "]

    //Crop Year Select Variables
    const [reportYears, setReportYears] = useState([]);
    const [selectedReportYearID, setSelectedReportYearID] = useState(null);

    const [companies, setCompanies] = useState([]);
    const [selectedCompanyID, setSelectedCompanyID] = useState(null);

    const [rowLabels, setRowLabels] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [dataSheet, setDataSheet] = useState([
        [],
        [],
    ]);

    const removeRow = (id) => {
        Swal.fire({
            title: 'Are you sure, you want delete the register?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonColor: '#102A63',
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                Api.post(`SubSectionKPI/deleteDefaultValue?id=${id}`).then((result) => {
                    if (selectedReportYearID && selectedCompanyID) {
                        loadDataByReportYear(selectedReportYearID, selectedCompanyID)
                    }
                })
            }
        })
    }

    const deleteAll = () => {
        Swal.fire({
            title: 'Are you sure, you want delete all?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonColor: '#102A63',
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                Api.post(`SubSectionKPI/deleteAllDefaultValue?reportYearID=${selectedReportYearID}&companyID=${selectedCompanyID}`).then((result) => {
                    if (result.data.response == true) {
                        if (selectedReportYearID && selectedCompanyID) {
                            success_message("All values was deleted successfully!")
                            setTimeout(() => {
                                loadDataByReportYear(selectedReportYearID, selectedCompanyID)
                            }, 2000)

                        }
                    }
                    else {
                        error_message("Some error was happened. Please try again or contact the administrator.")
                    }
                })
            }
        })
    }

    const InputNumberEdit = ({ cell, onChange }) => {
        var rowID = cell.className.split("-");
        return (
            <div style={{ padding: '0.5rem 1rem', textAlign: "center" }} onClick={() => removeRow(rowID[1])}>
                <FaTrashAlt />
            </div>
        );
    };

    const InputOptions = ({ cell, onChange }) => {

        return (
            <div style={{ padding: '0.5rem 1rem' }}>
                <img src={optionsLogo} alt="" />
            </div>
        );
    };


    useEffect(() => {
        var userObjectAux = JSON.parse(localStorage.getItem('@Thrive:user'));
        setIsLoading(true);
        loadReportYears(userObjectAux);
        loadCompanies();
    }, [])


    useEffect(() => {
        if (selectedReportYearID && selectedCompanyID) {
            setIsLoading(true);
            loadDataByReportYear(selectedReportYearID, selectedCompanyID)
        }
    }, [selectedReportYearID, selectedCompanyID])

    const loadReportYears = (userObjectAux) => {
        Api.get(`thriveValue/getAllCropsYears?selectedCulture=${userObjectAux.selectedCultureID}`).then((result) => {
            if (result && result.data) {
                setReportYears(result.data.response);
                var currentYear = result.data.response.find(x => x.year == new Date().getFullYear());
                setSelectedReportYearID(currentYear?.reportYearID != null ? currentYear?.reportYearID : result.data.response[0].reportYearID);
                setIsLoading(false)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeReportYearID = (value) => {
        setSelectedReportYearID(value);
    }

    const loadCompanies = () => {
        Api.get(`Company/getAllByCulture?cultureID=1`).then((result) => {
            if (result && result.data) {
                setCompanies(result.data.response);
                setSelectedCompanyID(result.data.response[0].companyID);
                setIsLoading(false)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeCompanyID = (value) => {
        setSelectedCompanyID(value);
    }

    const loadDataByReportYear = () => {
        if (selectedReportYearID && selectedCompanyID) {
            Api.get(`SubSectionKPI/getAllDefaultValuesByReportYear?reportYearID=${selectedReportYearID}&companyID=${selectedCompanyID}`).then((result) => {
                if (result && result.data) {
                    var resultList = [...result.data.response];
                    var newLine = [
                        { value: "" }, { value: "" }
                    ]
                    resultList.push(newLine);
                    setIsLoading(false)

                    try {
                        var resultDatasheet = [];
                        try {
                            var rowLabel = [];
                            resultDatasheet = resultList.map((row) => {
                                var res = [];

                                var id = row.subsectionKPICompanyDefaultValueID;
                                var answer = row.numberValue != null ? row.numberValue : row.textValue;
                                res[0] = { value: row.refNumber }
                                res[1] = { value: answer }
                                res[2] = { readOnly: false, className: 'remove-' + id, onClick: () => removeRow(id) };
                                res[2].DataViewer = InputOptions;
                                res[2].DataEditor = InputNumberEdit;
                                rowLabel.push(id);
                                return res;
                            })
                            setRowLabels(rowLabel);
                        } catch { }


                        setDataSheet(resultDatasheet);
                    } catch (e) {
                        console.log(e)
                    }

                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        }

    }

    const save = () => {

        var objDefaultValues = {
            reportYearID: selectedReportYearID,
            companyID: selectedCompanyID,
            IDs: rowLabels,
            data: dataSheet
        }
        setIsLoading(true);

        Api.post(`SubSectionKpi/NewDefaultValue`, objDefaultValues).then((result) => {
            if (result && result.data) {
                setIsLoading(false);
                if (result.data.response == true) {
                    success_message("The data was saved!");
                }
                else {
                    info_message("No data to saved!");
                }
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeTable = (e) => {
        try {
            setDataSheet(e);
        } catch { }
    }

    const onBlurTable = () => {
        try {
            var nesw = dataSheet.map((row) => {
                var newRow = row.map((col) => {
                    var newCol = { ...col };
                    return newCol;
                })
                return newRow;
            })

            try {
                nesw.map((row, i) => {
                    row[0] = { value: row[0].value }
                    row[2] = { readOnly: false, className: 'remove-' + row[0].value, onClick: () => removeRow(row[0].value) };
                    row[2].DataViewer = InputOptions;
                    row[2].DataEditor = InputNumberEdit;
                })

            } catch { }
            setDataSheet(nesw);
        } catch (e) {
            console.log(e)
        }
    }



    return (
        <Container className="container">
            <ContainerHeader style={{ margin: '2rem 0' }}>
                <h3>Additional Data - Default Values</h3>
                <div>
                    <Button style={{ marginRight: '15px' }} onClick={() => save()}>Save</Button>
                    <Button style={{ marginRight: '15px' }} onClick={() => deleteAll()}>Delete All</Button>
                </div>
            </ContainerHeader>
            <div className="row mt-2">
                <div className="col-md-6 mt-2 mx-4" style={{ width: '100%' }}>
                    <label className='label'>Select Reporting Year:</label>
                    <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={reportYears?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                            value={reportYears?.find((y) => y.reportYearID === selectedReportYearID) ? { value: selectedReportYearID, label: reportYears.find((y) => y.reportYearID === selectedReportYearID).year } : null}
                            onChange={(x) => onChangeReportYearID(x?.value ?? '')}
                            placeholder="Select Reporting Year"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="additionaldata-default-reportyear"
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-2 mx-4" style={{ width: '100%' }}>
                    <label className='label'>Select Company:</label>
                    <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={companies?.map((c) => ({ value: c.companyID, label: c.name })) ?? []}
                            value={companies?.find((c) => c.companyID === selectedCompanyID) ? { value: selectedCompanyID, label: companies.find((c) => c.companyID === selectedCompanyID).name } : null}
                            onChange={(x) => onChangeCompanyID(x?.value ?? '')}
                            placeholder="Select Company"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="additionaldata-default-company"
                        />
                    </div>
                </div>
            </div>
            {!isLoading ?
                <Spreadsheet data={dataSheet} rowLabels={rowLabels} columnLabels={columns} onBlur={() => onBlurTable()} onChange={(e) => onChangeTable(e)} />
                :
                <TableLoading />
            }
        </Container>
    )
}

export default AdditionalDataDefaultValuesForm;

